/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { encounterprogressnotesreference } from './subs/encounterprogressnotesreference';
import { externaldatareference } from './subs/externaldatareference';
import { observation } from './subs/observation';

export class diagnosis extends IceEntity {
	diagnosis_key: string = "";
  trans_account: string = "";
  onset_of_illness_date: any = NaN;
  resolution_date: any = NaN;
  icd_code: string = "";
  title: string = "";
  sub_type: number = 0;
  state_type: IceTypes.problemstate = IceTypes.problemstate.stateCurrent;
  status_type: IceTypes.problemstatus = IceTypes.problemstatus.statusActive;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  viral_load: number = 0;
  cd4: number = 0;

  OBSERVS: observation[] = [];
  NOTES: encounterprogressnotesreference[] = [];
  EXTDATAREFS: externaldatareference[] = [];

  gettablename(): string {
    return "DIAGNOSIS";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "NOTES") return true;
    else if (ColumnName == "OBSERVS") return true;
    else if (ColumnName == "GLRULES") return true;
    else if (ColumnName == "EXTDATAREFS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "NOTES") return "ENCOUNTER_PROGRESS_NOTES_REFERENCE";
    else if (ColumnName == "OBSERVS") return "OBSERVATION";
    else if (ColumnName == "GLRULES") return "MANAGEMENT_GUIDELINE";
    else if (ColumnName == "EXTDATAREFS") return "EXTERNAL_DATA_REFERENCE";

    return null;
  }
}
